export default "dist/images/09.png"